<template>
  <div>
    <!-- <pre>{{ data_text }}</pre>
    <pre>{{ get_value }}</pre> -->
    <!-- <pre>{{ select_report }}</pre> -->
    <!-- <pre>{{ items.data }}</pre> -->
    <vs-card class="cardRadi">
      <div slot="header">
        <h3>Data Export</h3>
      </div>
      <vs-row vs-align="flex-start" vs-type="flex" class="p-3" vs-justify="flex-start" vs-w="12">
        <vs-row class="p-3">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
            <vs-select class="selectExample mt-2 container-fluid" label="Export" v-model="value_export">
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="(item, index) in options_export" />
            </vs-select>
          </vs-col>
        </vs-row>
      </vs-row>

      <vs-row v-if="[true].includes(value_export)" vs-align="flex-start" vs-type="flex" class="p-3"
        vs-justify="flex-start" vs-w="12">
        <vs-row vs-align="flex-end" vs-type="flex" class="p-3" vs-justify="flex-start" vs-w="12"
          v-if="select_report.plan">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
            <vs-select class="selectExample mt-2 container-fluid" label="Device" v-model="select_report_device.plan">
              <vs-select-item :key="index" :value="item.device" :text="item.device" v-for="(item, index) in device_all" />
            </vs-select>
          </vs-col>

          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            <div style="display: flex; flex-direction: column">
              <label style="
                  padding-left: 5px;
                  color: var(--text-color-2);
                  font-size: 0.85rem;
                ">Start Date</label>
              <datetime style="width: 100%" format="yyyy-MM-dd HH:mm:ss" v-model="select_report_device.startTime"
                type="datetime" />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
            <div style="display: flex; flex-direction: column">
              <label style="
                  padding-left: 5px;
                  color: var(--text-color-2);
                  font-size: 0.85rem;
                ">End Date</label>
              <datetime style="width: 100%" format="yyyy-MM-dd HH:mm:ss" v-model="select_report_device.endTime"
                type="datetime" />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            <vs-button @click="callreport(select_report_device)" color="success" class="btnSub mt-4 mb-2"
              type="filled">Submit</vs-button>
          </vs-col>
        </vs-row>
      </vs-row>

      <!-- Dashboard -->
      <vs-row v-if="[false].includes(value_export)" vs-align="flex-start" vs-type="flex" class="p-3"
        vs-justify="flex-start" vs-w="12">
        <vs-row class="p-3">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
            <vs-select class="selectExample mt-2 container-fluid" label="Dashboard" v-model="select_report.plan">
              <vs-select-item :key="index" :value="item.textkey" :text="item.text"
                v-for="(item, index) in options_plan" />
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row vs-align="flex-start" vs-type="flex" class="p-3" vs-justify="flex-start" vs-w="12"
          v-if="select_report.plan">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
            <vs-select class="selectExample mt-2 container-fluid" label="Duration" v-model="select_report.duration">
              <vs-select-item :key="index" :value="item.text" :text="item.text"
                v-for="(item, index) in options_duration" />
            </vs-select>
          </vs-col>

          <vs-col v-if="['month'].includes(select_report.duration)" vs-type="flex" vs-justify="center" vs-align="center"
            vs-lg="2" vs-sm="4" vs-xs="12">
            <vs-select class="selectExample mt-2 container-fluid" label="Month" v-model="select_report.month">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options_month" />
            </vs-select>
          </vs-col>
          <vs-col v-if="select_report.duration" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4"
            vs-xs="12">
            <vs-select class="selectExample mt-2 container-fluid" label="Year" v-model="select_report.year">
              <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in options_year" />
            </vs-select>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            <vs-button @click="showPlan(select_report)" color="success" class="btnSub mt-4 mb-2"
              type="filled">Submit</vs-button>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-card>

    <vs-card v-if="[false].includes(value_export) && active" id="div-with-loading"
      class="cardRadi vs-con-loading__container">
      <reportexportvol v-if="selected === 'Volt'" :items="items" />
      <reportSubContact v-if="selected === 'Sub'" :select_plan="select_report.plan"
        :select_duration="select_report.duration" :items="items" :select_year="exp_year" :data_text="data_text" />
      <reportSP1 v-if="selected === 'SP1'" :items="items" />
      <reportSP2 v-if="selected === 'SP2'" :select_plan="select_report.plan" :select_duration="select_report.duration"
        :items="items" :select_year="exp_year" :data_text="data_text" />
      <reportSP2Non v-if="selected === 'SP2'" :select_plan="select_report.plan" :select_duration="select_report.duration"
        :items="items" :select_year="exp_year" :data_text="data_text" />
      <reportSP3 v-if="selected === 'SP3'" :select_plan="select_report.plan" :select_duration="select_report.duration"
        :items="items" :select_year="exp_year" :data_text="data_text" />
      <reportJP v-if="selected === 'JP'" :select_plan="select_report.plan" :select_duration="select_report.duration"
        :items="items" :select_year="exp_year" :data_text="data_text" />
      <reportUM v-if="selected === 'UM'" :select_plan="select_report.plan" :select_duration="select_report.duration"
        :items="items" :select_year="exp_year" :data_text="data_text" />
      <reportEX1 v-if="selected === 'EX1'" :select_plan="select_report.plan" :select_duration="select_report.duration"
        :items="items" :select_year="exp_year" :data_text="data_text" />
      <reportEX2 v-if="selected === 'EX2'" :select_plan="select_report.plan" :select_duration="select_report.duration"
        :items="items" :select_year="exp_year" :data_text="data_text" />
      <!-- <reportWH
        v-if="selected === 'WH'"
        :select_plan="select_report.plan"
        :select_duration="select_report.duration"
        :items="items"
        :select_year="exp_year"
        :data_text="data_text"
      />
      <reportGA
        v-if="selected === 'GA'"
        :select_plan="select_report.plan"
        :select_duration="select_report.duration"
        :items="items"
        :select_year="exp_year"
        :data_text="data_text"
      /> -->
    </vs-card>
  </div>
</template>

<script>
import reportexport from "./report/report_default.vue";
import reportexportvol from "./report/report_vol.vue";
import reportSubContact from "./report/report_SubContact.vue";
import reportSP1 from "./report/report_sp1.vue";
import reportSP2 from "./report/report_sp2.vue";
import reportSP2Non from "./report/report_sp2_non_boi.vue";
import reportSP3 from "./report/report_sp3.vue";
import reportJP from "./report/report_jp.vue";
import reportUM from "./report/report_um.vue";
import reportEX1 from "./report/report_EX1.vue";
import reportEX2 from "./report/report_EX2.vue";
import moment from "moment";
import XLSX from "xlsx"; // import xlsx
// import reportWH from "./report/report_WH.vue";
// import reportGA from "./report/report_GA.vue";
export default {
  components: {
    reportexport,
    reportexportvol,
    reportSubContact,
    reportSP1,
    reportSP2,
    reportSP2Non,
    reportSP3,
    reportJP,
    reportUM,
    reportEX1,
    reportEX2,
    // reportWH,
    // reportGA,
  },
  data() {
    return {
      active: false,
      result_exp_data: [],
      select_report_device: { plan: "", startTime: "", endTime: "" },
      options_export: [
        { text: "Report", value: true },
        { text: "Dashboard", value: false },
      ],
      value_export: null,
      selected: "",
      get_value: [],
      select_plan: "",
      show_plan: "",
      options_plan: [
        { text: "Volt", value: 1, textkey: "Volt" },
        // { text: "Sub Contact", value: 2, textkey: "Sub" },
        { text: "UM substation", value: 3, textkey: "UM" },
        { text: "SP1 substation", value: 4, textkey: "SP1" },
        { text: "SP2 substation", value: 5, textkey: "SP2" },
        { text: "SP3 substation", value: 6, textkey: "SP3" },
        { text: "JP substation", value: 7, textkey: "JP" },
        // { text: "EX1 substation", value: 8, textkey: "EX1" },
        // { text: "EX2 substation", value: 9, textkey: "EX2" },
        // { text: "WH substation", value: 10, textkey: "WH" },
        // { text: "GA substation", value: 11, textkey: "GA" },
      ],
      options_week: [
        { text: "1-7", value: "01" },
        { text: "8-14", value: "08" },
        { text: "15-21", value: "15" },
        { text: "22-31", value: "22" },
        // { text: "Week 5", value: "29" },
      ],
      options_duration: [
        // { text: "1 day", value: 1 },
        // { text: "week", value: 1 },
        { text: "month", value: 2 },
        { text: "year", value: 3 },
      ],
      options_month: [
        // { text: "1 day", value: 1 },
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
      select_month: { value: "01" },
      select_week: { value: "01" },
      select_year: null,
      select_report: { plan: "month", month: "01", year: "2023" },
      get_month: null,
      get_week: null,
      get_year: null,
      options_year: [
        // { text: "1 day", value: 1 },
        // { text: "2021", value: 2021 },
        // { text: "2020", value: 2020 },
        // { text: "2019", value: 2019 },
        // { text: "2018", value: 2018 },
        // { text: "2017", value: 2017 },
      ],
      items: [],
      items_year: [
        {
          age: 2040,
          first_name: "MAR",
          last_name: "Macdonald",
          water_toilet: 2522,
          water_treat: 6587,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 2001,
          first_name: "APR",
          last_name: "Shaw",
          water_toilet: 2929,
          water_treat: 7485,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 2309,
          first_name: "MAY",
          last_name: "Wilson",
          water_toilet: 3235,
          water_treat: 7959,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1040,
          first_name: "JUN",
          last_name: "MacDonald",
          water_toilet: 2325,
          water_treat: 2522,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1129,
          first_name: "JUL",
          last_name: "Dunlap",
          water_toilet: 1714,
          water_treat: 7485,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 3329,
          first_name: "AUG",
          last_name: "Dunlap",
          water_toilet: 2017,
          water_treat: 5803,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1129,
          first_name: "SEP",
          last_name: "Dunlap",
          water_toilet: 2694,
          water_treat: 6243,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1129,
          first_name: "OCT",
          last_name: "Dunlap",
          water_toilet: 2292,
          water_treat: 2522,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1129,
          first_name: "NOV",
          last_name: "Dunlap",
          water_toilet: 3259,
          water_treat: 2522,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1129,
          first_name: "DEC",
          last_name: "Dunlap",
          water_toilet: 2522,
          water_treat: 6038,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
      ],
      items_week: [
        {
          age: 2040,
          first_name: "Sunday",
          last_name: "Macdonald",
          water_toilet: 2522,
          water_treat: 6587,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 2001,
          first_name: "Monday",
          last_name: "Shaw",
          water_toilet: 2929,
          water_treat: 7485,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 2309,
          first_name: "Tuesday",
          last_name: "Wilson",
          water_toilet: 3235,
          water_treat: 7959,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1040,
          first_name: "Wednesday",
          last_name: "MacDonald",
          water_toilet: 2325,
          water_treat: 2522,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1040,
          first_name: "Thursday",
          last_name: "MacDonald",
          water_toilet: 2325,
          water_treat: 2522,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1040,
          first_name: "Friday",
          last_name: "MacDonald",
          water_toilet: 2325,
          water_treat: 2522,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1040,
          first_name: "Saturday",
          last_name: "MacDonald",
          water_toilet: 2325,
          water_treat: 2522,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
      ],
      items_month: [
        {
          age: 2040,
          first_name: "Week 1",
          last_name: "Macdonald",
          water_toilet: 2522,
          water_treat: 6587,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 2001,
          first_name: "Week 2",
          last_name: "Shaw",
          water_toilet: 2929,
          water_treat: 7485,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 2309,
          first_name: "Week 3",
          last_name: "Wilson",
          water_toilet: 3235,
          water_treat: 7959,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
        {
          age: 1040,
          first_name: "Week 4",
          last_name: "MacDonald",
          water_toilet: 2325,
          water_treat: 2522,
          electricity: "",
          sludge: "-",
          cost_of_electricity: 74643.28,
          cost_of_sludge: 74643.28,
          total_cost: "",
          cost_of_chem1: 3.94,
          cost_of_chem2: 3.94,
        },
      ],

      exp_year: null,
      value_cal: {
        powerData: 0,
        waterData: 0,
      },
      data_text: {
        type: 0,
        month: "",
        week: "",
        year: "",
      },
      re: {},
      device_all: {},
      data_re: [],
      username: '',
    };
  },
  methods: {
    generateArrayOfYears() {
      var max = new Date().getFullYear();
      var min = max - 10;
      var years = [];

      for (var i = max; i >= min; i--) {
        years.push(i);
      }

      return years;
    },
    async showPlan(item) {
      // item.forEach((element) => {
      //   console.log(element.length);
      // });
      this.active = true;
      this.$vs.loading();

      let body = {
        Dashboard: item.plan,
        Duration: item.duration,
        date: item.year + "-" + item.month + "-01",
      };
      console.log(body);
      this.re = body;
      try {
        let res = await this.$API.post("ajino-get-report", body);
        if (res.status === 200) {
          this.items = res.data;
          console.log(this.items.message);
          this.selected = this.select_report.plan;
          this.$vs.loading.close();
          if (this.items.message.data.length == 0) {
            this.active = false;
            this.$vs.notify({
              title: "Color",
              icon: "sim_card_alert",
              text: "No data available",
              color: "warning",
              position: "top-center",
              time: 4000,
            });
          }
        }
      } catch (error) {
        this.$vs.loading.close();
        this.active = false;
        this.$vs.notify({
          title: "Warning",
          text: "Unable to load the data.",
          color: "danger",
          position: "top-center",
          time: 4000,
          icon: "warning",
        });
      }

      this.active = true;
    },
    callreport(item) {
      console.log(item);
      this.$vs.loading();
      let body_command = {
        device: item.plan,
        timeStart: item.startTime,
        timeEnd: item.endTime,
      };
      console.log(body_command);
      this.$API
        .post(`ajino-get-report-one-device`, body_command)
        .then((result) => {
          this.$vs.loading.close();
          // console.log(result.data.message);
          const dataWS = XLSX.utils.json_to_sheet(result.data.message);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, item.plan + ".xlsx");

          this.$vs.notify({
            title: "Success",
            color: "success",
            position: "top-center",
            time: 6000,
            icon: "done",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: "Please try again later.",
            icon: "warning",
            color: "danger",
          });
        });
    },
    calldevice() {
      if (this.$session.get("admin") === "awcdemo") return
      this.$API.get(`ajino-get-one-device`).then((result) => {
        // console.log("dddddddddddddddddddddddddddddddddddddddddddddddddd");
        // console.log(result.data.message);
        switch (this.username) {
          case 'ajtnk-sp1':
            this.device_all = result.data.message.filter((val) => val.device.startsWith('SP1'));
            break;
          case 'ajtnk-sp2':
            this.device_all = result.data.message.filter((val) => val.device.startsWith('SP2'));
            break;
          case 'ajtnk-sp3':
            this.device_all = result.data.message.filter((val) => val.device.startsWith('SP3'));
            break;
          case 'ajtnk-jp':
            this.device_all = result.data.message.filter((val) => val.device.startsWith('JP'));
            break;
          case 'ajtnk-ex':
            this.device_all = result.data.message.filter((val) => val.device.startsWith('MN-MDB_EX'));
            break;
          case 'ajtnk-ic':
            this.device_all = result.data.message.filter((val) => val.device.startsWith('SP1-CWH') || val.device.startsWith('MN-PWH'));
            break;
          case 'ajtnk-gc':
            this.device_all = result.data.message.filter((val) => val.device.startsWith('SP2-GA'));
            break;
          case 'ajtnk-tftc':
            this.device_all = result.data.message.filter((val) => val.device.startsWith('SP2-TFTC'));
            break;
          default:
            this.device_all = result.data.message
            break;
        }

        if (['ajinomotodemo', 'ajtnk-mn', 'ajtnk-ut'].includes(this.username)) {
          this.device_all.splice(0, 0, {
            device: "SP2 power consumption report",
          });
          this.device_all.splice(0, 0, {
            device: "SP1 power consumption report",
          });
          this.device_all.splice(0, 0, { device: "UM power consumption report" });
          this.device_all.splice(0, 0, { device: "All file" });
        }
        console.log(this.device_all);
      });
    },
  },
  mounted() {
    if (this.$session.get("admin") === "awcdemo") this.options_plan = []
    switch (this.username) {
          case 'ajtnk-sp1':
            this.options_plan = [{ text: "SP1 substation", value: 4, textkey: "SP1" },]
            break;
          case 'ajtnk-sp2':
            this.options_plan = [{ text: "SP2 substation", value: 5, textkey: "SP2" }]
            break;
          case 'ajtnk-sp3':
            this.options_plan = [{ text: "SP3 substation", value: 6, textkey: "SP3" }]
            break;
          case 'ajtnk-jp':
            this.options_plan = [{ text: "JP substation", value: 7, textkey: "JP" }]
            break;
          case 'ajtnk-ex':
            this.options_plan = []
            break;
          case 'ajtnk-ic':
            this.options_plan = []
            break;
          case 'ajtnk-gc':
            this.options_plan = []
            break;
          case 'ajtnk-tftc':
            this.options_plan = []
            break;
          default:
            this.options_plan = [
              { text: "Volt", value: 1, textkey: "Volt" },
              // { text: "Sub Contact", value: 2, textkey: "Sub" },
              { text: "UM substation", value: 3, textkey: "UM" },
              { text: "SP1 substation", value: 4, textkey: "SP1" },
              { text: "SP2 substation", value: 5, textkey: "SP2" },
              { text: "SP3 substation", value: 6, textkey: "SP3" },
              { text: "JP substation", value: 7, textkey: "JP" },
              // { text: "EX1 substation", value: 8, textkey: "EX1" },
              // { text: "EX2 substation", value: 9, textkey: "EX2" },
              // { text: "WH substation", value: 10, textkey: "WH" },
              // { text: "GA substation", value: 11, textkey: "GA" },
            ]
            break;
        }
    if (this.$session.get("admin") === "awcdemo") {}
    this.options_year = this.generateArrayOfYears();
    this.calldevice();
  },
  created() {
    this.username = this.$session.get("username");
  },
};
</script>

<style scoped>
.btnSub {
  width: 100px;
  border-radius: 20px;
}

.cardRadi {
  border-radius: 20px;
}
</style>
